// @TODO: Move to hooks
// eslint-disable-next-line no-case-declarations
import { useMemo } from "react";

/**
 * Build url query parameters.
 * @param {object} object
 * @returns {string}
 */
const objectToParams = (object = {}) => {
    const params = Object.entries(object)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                    String(value?.replace(/(<([^>]+)>)/gi, "")),
                )}`,
        );

    return params?.length > 0 ? `?${params.join("&")}` : "";
};

/**
 * Get share url.
 * @param {string} network
 * @param {string} url
 * @param {string} text - Pinterest description or Twitter text
 * @param {string} media - Pinterest media
 * @returns {string}
 */

const useShareUrl = (network, url, text, media) =>
    useMemo(() => {
        if (url) {
            switch (network) {
                case "facebook": {
                    const params = media ? { u: url, picture: media } : { u: url };
                    return `https://www.facebook.com/sharer/sharer.php${objectToParams(params)}`;
                }
                case "pinterest":
                    return `https://pinterest.com/pin/create/button/${objectToParams({
                        url,
                        media,
                        description: text,
                    })}`;
                case "twitter":
                    return `https://twitter.com/share${objectToParams({ url, text })}`;
                default:
                    return undefined;
            }
        }
        return undefined;
    }, [network, url, media, text]);

export default useShareUrl;
